var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteExpertWorkArrowdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 10,
    viewBox: "0 0 34 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.943956 1.29302C1.33464 1.10555 1.86445 1.00023 2.41687 1.00023C2.9693 1.00023 3.49911 1.10555 3.88979 1.29302L17.0002 7.58602L30.1106 1.29302C30.3028 1.19751 30.5327 1.12133 30.7869 1.06892C31.041 1.01651 31.3144 0.988924 31.591 0.98777C31.8677 0.986616 32.142 1.01192 32.398 1.0622C32.6541 1.11248 32.8867 1.18673 33.0823 1.28063C33.2779 1.37452 33.4326 1.48617 33.5373 1.60907C33.6421 1.73196 33.6948 1.86364 33.6924 1.99642C33.69 2.1292 33.6325 2.26042 33.5233 2.38242C33.4141 2.50443 33.2554 2.61477 33.0565 2.70702L18.4731 9.70702C18.0824 9.89449 17.5526 9.99981 17.0002 9.99981C16.4478 9.99981 15.918 9.89449 15.5273 9.70702L0.943956 2.70702C0.553392 2.51949 0.333984 2.26518 0.333984 2.00002C0.333984 1.73486 0.553392 1.48055 0.943956 1.29302Z",
    fill: "#02E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteExpertWorkArrowdown);
export default __webpack_public_path__ + "static/media/note-expert-work-arrowdown.643b66ac01aaccd4a378532d025ef0c1.svg";
export { ForwardRef as ReactComponent };